import { AddCustomTicketRequest } from './add.custom.ticket.request';

export class AddCustomTicketReplyRequest extends AddCustomTicketRequest {

    TicketID: number;
}
